<template v-if="list.length">
  <div>
    <table class="vacancies-table">
      <thead>
        <tr :class="{ search: isItSearch }">
          <th class="column-checkbox">
            <vchecklabel v-model="isEveryVacancySelected" />
          </th>

          <th class="column-name pointer">
            <div class="table_column_title">
              <i v-if="sorting.name === 'name' && !isItSearch" class="fa" :class="sortingIcon"></i>
              <div class="column_title" @click="setSortingMethod('name')">
                {{ $tr('common.list.vacancy') }}
              </div>
              <div class="column_filter" @click.stop="set_show_filter('vacancy')">
                <icon-filter :color="filter.vacancy_ids.length > 0 ? 'green' : 'grey'" />
              </div>
              <vtfilter
                v-if="show_filter === 'vacancy'"
                class="th_filter"
                :type="'list'"
                :list="filter_vacancies"
                :selected_list="filter_temp_selected_vacancies"
                :input_placeholder="$tr('vacancy.preferences.settings.vacancyName')"
                :filter_name="'vacancy'"
                @input="set_filter_temp_selected_vacancies"
                @apply="apply_filter('vacancy')"
                @cancel="cancel_filter"
                @clear="vacancy_clear"
              />
            </div>
          </th>

          <th class="column-numbers pointer" @click="setSortingMethod('sent_responses_count')">
            <div class="column-candidates">
              <div class="table_column_title">
                <i
                  v-if="sorting.name === 'sent_responses_count' && !isItSearch"
                  class="fa"
                  :class="sortingIcon"
                ></i>
                {{ $tr('common.list.candidates') }}
              </div>
              <span class="column-candidates-note">{{ $tr('common.list.candidatesNew') }}</span>
            </div>
          </th>

          <th class="column-landing">
            <div class="column-landing-content">
              <div class="table_column_title">
                {{ $tr('common.list.landing') }}
              </div>
            </div>
          </th>

          <th class="column-date pointer">
            <div class="table_column_title">
              <i
                v-if="sorting.name === 'created_at' && !isItSearch"
                class="fa"
                :class="sortingIcon"
              ></i>
              <div class="column_title" @click="setSortingMethod('created_at')">
                {{ $tr('common.list.date') }}
              </div>
              <div class="column_filter" @click.stop="set_show_filter('date')">
                <icon-filter :color="filter.dates.length > 0 ? 'green' : 'grey'" />
              </div>
              <vtfilter
                v-if="show_filter === 'date'"
                class="th_filter"
                :type="'date'"
                :dates="filter_temp_dates"
                @input="set_filter_temp_dates"
                @apply="apply_filter('dates')"
                @cancel="cancel_filter"
                @clear="date_clear"
              />
            </div>
          </th>

          <!--
            <th class="column-geo" @click="setSortingMethod('geo')">
            <i v-if="sorting.name === 'geo'" class="fa" :class="sortingIcon"></i>
            {{ $tr('common.list.region') }}
            </th>
          -->

          <th class="column-creator">
            <div class="table_column_title">
              <div class="column_title">{{ $tr('common.list.creator') }}</div>
              <div class="column_filter" @click.stop="set_show_filter('creator')">
                <icon-filter :color="filter.creators_ids.length > 0 ? 'green' : 'grey'" />
              </div>
              <vtfilter
                v-if="show_filter === 'creator'"
                class="th_filter"
                :type="'list'"
                :list="filter_creators"
                :selected_list="filter_temp_selected_creators"
                :input_placeholder="$tr('common.list.creator')"
                :filter_name="'creator'"
                @input="set_filter_temp_selected_creators"
                @apply="apply_filter('creator')"
                @cancel="cancel_filter"
                @clear="creator_clear"
              />
            </div>
          </th>

          <th class="column-modules right">
            <div class="table_column_title">
              <div class="column_title">{{ $tr('common.list.actions') }}</div>
              <div class="column_filter" @click.stop="set_show_filter('module')">
                <icon-filter :color="filter.modules_ids.length > 0 ? 'green' : 'grey'" />
              </div>
              <vtfilter
                v-if="show_filter === 'module'"
                class="th_filter right"
                :type="'list'"
                :list="filter_modules"
                :selected_list="filter_temp_selected_modules"
                :search="false"
                :filter_name="'module'"
                @input="set_filter_temp_selected_modules"
                @apply="apply_filter('module')"
                @cancel="cancel_filter"
                @clear="module_clear"
              />
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!list.length">
          <td colspan="99" class="no-records">{{ $tr('common.noRecords') }}</td>
        </tr>
        <vacancy-row
          v-for="item in list"
          v-if="list.length"
          :key="item.id"
          :model="item"
          :class="className"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
  import VacancyRow from './Row.vue';
  import moment from 'moment';

  export default {
    name: 'VacanciesList',

    components: {
      VacancyRow
    },

    props: {
      list: Array,
      isItSearch: {
        type: Boolean,
        default: false
      },

      className: String,
      activeVacancies: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        filter_temp_selected_vacancies: [],
        filter_temp_dates_arr: [],
        filter_temp_selected_creators: [],
        filter_temp_selected_modules: [],
        show_filter: 'none',
        filter_loaded: false,
        isSelectedAllFilters: {}
      };
    },

    computed: {
      ...mapState('vacancies', ['filters_request_time', 'filter', 'filters_list', 'sorting']),

      ...mapGetters('vacancies', ['getFilterQuery', 'getIsSelectedVacancies']),

      filter_vacancies() {
        if (!this.filters_list || !this.filters_list.filter_vacancies.length) {
          return [];
        }
        return this.filters_list.filter_vacancies;
      },

      filter_temp_dates: {
        get() {
          if (this.filter_temp_dates_arr && this.filter_temp_dates_arr.length) {
            return this.filter_temp_dates_arr;
          }
          if (!this.filters_list || !this.filters_list.filter_temp_dates.length) {
            return [];
          }
          return this.filters_list.filter_temp_dates;
        },

        set(v) {
          this.filter_temp_dates_arr = v;
        }
      },

      filter_creators() {
        if (!this.filters_list || !this.filters_list.filter_creators.length) {
          return [];
        }
        return this.filters_list.filter_creators;
      },

      filter_modules() {
        if (!this.filters_list || !this.filters_list.filter_modules.length) {
          return [];
        }
        return this.filters_list.filter_modules;
      },

      isEveryVacancySelected: {
        get() {
          if (!this.list.filter(vacancy => !this.isRoleReadOrScoring(vacancy)).length) {
            return false;
          }
          return this.list
            .filter(vacancy => !this.isRoleReadOrScoring(vacancy))
            .every(vacancy => this.getIsSelectedVacancies(vacancy));
        },

        set(state) {
          this.list
            .filter(vacancy => !this.isRoleReadOrScoring(vacancy))
            .forEach(vacancy =>
              this.setSelectedState({
                model: vacancy,
                state
              })
            );
        }
      },

      sortingIcon() {
        return {
          'fa-caret-down': this.sorting.order === 'desc',
          'fa-caret-up': this.sorting.order === 'asc'
        };
      }
    },

    created() {
      if (this.filter_vacancies && this.filter_vacancies.length) {
        if (this.filters_request_time && moment().diff(this.filters_request_time, 'minutes') < 15) {
          return;
        }
      }
      this.load_filters();
    },

    beforeDestroy() {
      this.isEveryVacancySelected = false;
    },

    methods: {
      ...mapMutations('vacancies', ['SET_SORTING', 'SET_FILTER_ITEM', 'SET_PAGINATION']),

      ...mapActions('vacancies', ['fetchVacancies', 'loadFiltersVacancies', 'setSelectedState']),
      setSortingMethod(method) {
        if (this.isItSearch) {
          return;
        }

        const sorting = this.sorting;
        this.SET_SORTING({
          name: method,
          order: sorting.name !== method || sorting.order === 'desc' ? 'asc' : 'desc'
        });
        this.fetch({
          isActive: this.activeVacancies
        });
      },

      isRoleReadOrScoring(vacancy) {
        if (!vacancy) {
          return false;
        }

        return vacancy.role === 'role_read' || vacancy.role === 'role_read_scoring';
      },

      set_filter_temp_selected_vacancies(model) {
        this.filter_temp_selected_vacancies = model.result;

        if (model.params && model.params.name) {
          this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
        }
      },

      set_filter_temp_dates(model) {
        this.filter_temp_dates = model.result;
      },

      set_filter_temp_selected_creators(model) {
        this.filter_temp_selected_creators = model.result;
        if (model.params && model.params.name) {
          this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
        }
      },

      set_filter_temp_selected_modules(model) {
        this.filter_temp_selected_modules = model.result;
        if (model.params && model.params.name) {
          this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
        }
      },

      apply_filter(filter) {
        if (this.isSelectedAllFilters[filter] && this[`${filter}_clear`]) {
          this[`${filter}_clear`]();
          return;
        }
        let query_filter = [...this.filter.query_filter];
        if (query_filter.indexOf(filter) === -1) {
          query_filter.push(filter);
        }
        this.SET_FILTER_ITEM({
          key: 'query_filter',
          v: query_filter
        });
        this.SET_FILTER_ITEM({
          key: 'vacancy_ids',
          v: this.filter_temp_selected_vacancies
        });
        this.SET_FILTER_ITEM({
          key: 'dates',
          v: this.filter_temp_dates
        });
        this.SET_FILTER_ITEM({
          key: 'creators_ids',
          v: this.filter_temp_selected_creators
        });
        this.SET_FILTER_ITEM({
          key: 'modules_ids',
          v: this.filter_temp_selected_modules
        });
        this.set_show_filter('none');
        this.SET_PAGINATION({ pageNumber: 1 });
        this.$emit('filterapply');
      },

      cancel_filter() {
        this.filter_temp_selected_vacancies = this.filter.vacancy_ids;
        this.filter_temp_dates = this.filter.dates;
        this.filter_temp_selected_creators = this.filter.creators_ids;
        this.filter_temp_selected_modules = this.filter.modules_ids;
        this.set_show_filter('none');
      },

      vacancy_clear() {
        let query_filter = this.filter.query_filter.filter(i => i !== 'vacancy');
        this.SET_FILTER_ITEM({
          key: 'query_filter',
          v: query_filter
        });
        this.filter_temp_selected_vacancies = [];
        this.SET_FILTER_ITEM({
          key: 'vacancy_ids',
          v: []
        });
        this.set_show_filter('none');
        this.$emit('filterapply');
      },

      date_clear() {
        let query_filter = this.filter.query_filter.filter(i => i !== 'dates');
        this.SET_FILTER_ITEM({
          key: 'query_filter',
          v: query_filter
        });
        this.filter_temp_dates = [];
        this.SET_FILTER_ITEM({ key: 'dates', v: [] });
        this.set_show_filter('none');
        this.$emit('filterapply');
      },

      creator_clear() {
        let query_filter = this.filter.query_filter.filter(i => i !== 'creator');
        this.SET_FILTER_ITEM({
          key: 'query_filter',
          v: query_filter
        });
        this.filter_temp_selected_creators = [];
        this.SET_FILTER_ITEM({
          key: 'creators_ids',
          v: []
        });
        this.set_show_filter('none');
        this.$emit('filterapply');
      },

      module_clear() {
        let query_filter = this.filter.query_filter.filter(i => i !== 'module');
        this.SET_FILTER_ITEM({
          key: 'query_filter',
          v: query_filter
        });
        this.filter_temp_selected_modules = [];
        this.SET_FILTER_ITEM({
          key: 'modules_ids',
          v: []
        });
        this.set_show_filter('none');
        this.$emit('filterapply');
      },

      set_show_filter(v) {
        this.show_filter = v;
        this.filter_temp_selected_vacancies = this.filter.vacancy_ids;
        this.filter_temp_dates = this.filter.dates;
        this.filter_temp_selected_creators = this.filter.creators_ids;
        this.filter_temp_selected_modules = this.filter.modules_ids;
      },

      load_filters() {
        console.log('load_filters()', this.getFilterQuery);
        this.loadFiltersVacancies({
          filter: this.getFilterQuery,
          activeVacancies: this.activeVacancies
        }).then(() => {
          this.filter_loaded = true;
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '../../styles/variables.scss';

  .table_column_title {
    position: relative;
    display: inline-flex;
    .column_filter {
      margin-left: 9px;
      margin-top: 1px;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
    .fa {
      margin-right: 5px;
    }
  }
  .search th:hover {
    cursor: default;
  }

  .column-date {
    width: 8.1%;

    @media (max-width: 1780px) {
      width: 20%;
    }

    @media (min-width: 2100px) {
      width: 325px;
    }
  }

  .column-name {
    width: 15%;

    @media (max-width: 1780px) {
      width: 20%;
    }

    @media (min-width: 2100px) {
      width: 325px;
    }
  }

  .column-numbers {
    width: 8.1%;
    padding-top: 18px;

    @media (max-width: 1780px) {
      width: 20%;
    }

    @media (min-width: 2100px) {
      width: 325px;
    }

    span {
      display: block;
    }
  }

  .column-creator {
    width: 17%;

    @media (max-width: 1780px) {
      width: 20%;
    }

    @media (min-width: 2100px) {
      width: 325px;
    }
  }

  .column-modules {
    cursor: default;
    width: 50%;
    &.right {
      padding-right: 0;
    }

    @media (max-width: 1780px) {
      width: 20%;
    }

    @media (min-width: 2100px) {
      width: 99%;
    }
  }
  .th_filter {
    position: absolute;
    left: 0;
    top: 30px;
    margin-top: 10px;

    &.right {
      right: -130px;
      left: auto;
    }
  }
  table.vacancies-table {
    position: relative;
    height: 100%;
    margin-left: -24px;
    margin-right: -24px;
    margin-bottom: 50px;
    width: calc(100% + 48px);
    table-layout: fixed;
    z-index: 1;

    ::v-deep th {
      position: static;
      position: sticky;
      top: 138px;
      background-color: #fff;
      z-index: 3;

      &:after {
        width: 100%;
        height: 1px;
        background-color: #e5e5e5;
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }

    ::v-deep {
      thead {
        tr {
          height: 48px;
        }
      }

      tbody {
        tr {
          height: 59px;
        }
      }
      tr {
        td,
        th {
          &.column-checkbox {
            width: 40px;
            max-width: 40px;
            padding-right: 24px;
            padding-left: 24px;
            box-sizing: border-box;
          }
        }

        th {
          padding: 0px 8px;
          cursor: default;

          &.pointer {
            cursor: pointer;
          }
        }

        td {
          padding: 0px 8px;
        }
      }
    }
  }

  .column-candidates {
    position: relative;
    display: inline-flex;
    flex-direction: column;
  }

  .column-candidates-note {
    position: absolute;
    font-size: $mini-text-size;
    line-height: $mini-text-line-height;
    font-weight: $mini-text-font-weight;
    width: 100%;
    bottom: -12px;
    left: 0;
    white-space: nowrap;
    color: $gray-hints;
  }

  .column-landing {
    width: 20%;
  }

  .vacancies-table-hidden-header {
    height: 0px;
    ::v-deep {
      tr {
        height: 0 !important;
      }
      th {
        padding-top: 0 !important;
        padding-bottom: 0;
      }
    }
  }
</style>
